import { baseApi } from '@ibk/shared-config';
export const contractApi = baseApi.injectEndpoints({
    endpoints: build => ({
        getProductBySlug: build.query({
            query: ({ slug }) => ({
                url: `/v1/products/management`,
                params: { slug },
            }),
            transformResponse: (response) => {
                return response.result;
            },
            providesTags: ['ProductManagement'],
        }),
        acceptTerm: build.mutation({
            query: body => ({
                url: '/v1/products/management/term-acceptance',
                method: 'POST',
                body,
            }),
            transformResponse: (response) => {
                return response.result;
            },
        }),
    }),
    overrideExisting: false,
});
export const { useLazyGetProductBySlugQuery, useAcceptTermMutation } = contractApi;
